/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const addTicketMessageRequestSchema = z.object({
  text: z.string().min(1).max(2000),
});

export type IAddTicketMessageRequest = z.infer<typeof addTicketMessageRequestSchema>;
